let productSlider = null;
let quickShopSlider = null;


/**
  * local storage based hide/show content
  *
  * */
let websiteType = Utility.getCookie('websiteType');
if(websiteType == 'dreamworld'){
  /* For Mobile logo's */
  document.querySelectorAll('[data-web-type="type2"]').forEach(element => element.classList.remove('d-none'));
  document.querySelectorAll('[data-web-type="type1"]').forEach(element => element.classList.add('d-none'));
  document.querySelectorAll('[data-web-type="type3"]').forEach(element => element.classList.add('d-none'));

  /* For Desktop logo's */
  document.querySelectorAll('[data-web-type-lg="type2"]').forEach(element => element.classList.remove('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type1"]').forEach(element => element.classList.add('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type3"]').forEach(element => element.classList.add('d-lg-none'));

  /* For announcement bar message */
  document.querySelectorAll('[data-tab-type="type2"]').forEach(element => element.classList.add('active'));
  document.querySelectorAll('[data-tab-type="type1"]').forEach(element => element.classList.remove('active'));
  document.querySelectorAll('[data-tab-type="type3"]').forEach(element => element.classList.remove('active'));
  
  // search element
  let searchEles = document.querySelectorAll('[data-searchtype]');
  searchEles.forEach(ele => {
    ele.setAttribute('data-searchtype','dreamworld')
  })

}else if(websiteType == 'urbanbeauty'){

  /* For Mobile logo's */
  document.querySelectorAll('[data-web-type="type3"]').forEach(element => element.classList.remove('d-none'));
  document.querySelectorAll('[data-web-type="type1"]').forEach(element => element.classList.add('d-none'));
  document.querySelectorAll('[data-web-type="type2"]').forEach(element => element.classList.add('d-none'));

  /* For Desktop logo's */
  document.querySelectorAll('[data-web-type-lg="type3"]').forEach(element => element.classList.remove('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type1"]').forEach(element => element.classList.add('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type2"]').forEach(element => element.classList.add('d-lg-none'));

  /* For announcement bar message */
  document.querySelectorAll('[data-tab-type="type3"]').forEach(element => element.classList.add('active'));
  document.querySelectorAll('[data-tab-type="type1"]').forEach(element => element.classList.remove('active'));
  document.querySelectorAll('[data-tab-type="type2"]').forEach(element => element.classList.remove('active'));

  // search element
  let searchEles = document.querySelectorAll('[data-searchtype]');
  searchEles.forEach(ele => {
    ele.setAttribute('data-searchtype','urbanbeauty')
  })

}else if(websiteType == 'jinnybeauty'){
  /* For Mobile logo's */
  document.querySelectorAll('[data-web-type="type1"]').forEach(element => element.classList.remove('d-none'));
  document.querySelectorAll('[data-web-type="type2"]').forEach(element => element.classList.add('d-none'));
  document.querySelectorAll('[data-web-type="type3"]').forEach(element => element.classList.add('d-none'));

  /* For Desktop logo's */
  document.querySelectorAll('[data-web-type-lg="type1"]').forEach(element => element.classList.remove('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type2"]').forEach(element => element.classList.add('d-lg-none'));
  document.querySelectorAll('[data-web-type-lg="type3"]').forEach(element => element.classList.add('d-lg-none'));

  /* For announcement bar message */
  document.querySelectorAll('[data-tab-type="type1"]').forEach(element => element.classList.add('active'));
  document.querySelectorAll('[data-tab-type="type2"]').forEach(element => element.classList.remove('active'));
  document.querySelectorAll('[data-tab-type="type3"]').forEach(element => element.classList.remove('active'));

  let searchEles = document.querySelectorAll('[data-searchtype]');
  searchEles.forEach(ele => {
    ele.setAttribute('data-searchtype','jinnybeauty')
  })

}


/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
  * prevent body Touch event in Touch devices when Overlay is visible
  *
  * @param {event} event - event instance
*/
function bodyTouchMove(event){
  let currentTarget = event.target;
  if (!currentTarget.closest('[data-touch-moveable]')) {
    event.preventDefault();
    return false;
  }
}

/**
  * Limit the number of times a function is called within defined timeout
  *
  * @param {form} form - Form to serialize
*/
const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

/**
  * Fetch call config
  *
  * @param {string} type - request Accept type
*/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 function dropDownInit(element){
 
  const dropdownParent = element.parentElement;
  const dropdownEle = element;
 
  ["mouseover", "focusin",  "click", "mouseout"].forEach(function(type){
    if(type == 'click'){
      dropdownEle.addEventListener(type, (evt) => {
        evt.stopPropagation();
        let currentTarget = evt.currentTarget;
        let liveTarget = evt.target;
        if(liveTarget.classList.contains('nav-link-title')){
          let linkHref = currentTarget.getAttribute('data-href');
          if(linkHref) window.location.href = linkHref;
        }else {
          dropdownToggle(dropdownParent);
        }
      });
    }else if(type == 'mouseout'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownHide(dropdownParent);
        }
      }, true);
    } else if(type == 'mouseover' || type == 'focusin'){
      dropdownParent.addEventListener(type, (event) => {
        let mobileContainer = event.currentTarget.closest('[data-touch-moveable]');
        if(!mobileContainer){
          dropdownShow(dropdownParent); 
        }
      });
      dropdownEle.addEventListener(type, (e) => { ChildonFocusChange(dropdownParent); });
    }
  });

  dropdownParent.addEventListener('keyup', (event) => {
    if (event.code.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget, event.type); }
    if (event.code.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
  });

  function dropdownToggle(dropdownParent) {
    setTimeout(function(){
      dropdownParent.classList.contains('open')
        ? dropdownHide(dropdownParent)
        : dropdownShow(dropdownParent);
    }, 50);
  }

  function dropdownShow(dropdownParent){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', true);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.add('open');
    }else{
      Utility.toggleElement(dropdownParent, 'open');
    }
  }

  function dropdownHide(dropdownParent, eventType){
    if(!dropdownParent){
      return;
    }

    dropdownEle.setAttribute('aria-expanded', false);
    if(!dropdownParent.closest('[data-role="drawer"]')){
      dropdownParent.classList.remove('open');
    }else{
      Utility.toggleElement(dropdownParent, 'close');
    }

    if(eventType == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
      dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
    }

    let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if(childDropdowns.length > 0){
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        if(child.querySelector('a[data-toggle="open"]'))
          child.querySelector('a[data-toggle="open"]').setAttribute('aria-expanded', false);
      });
    }
  }

  function ChildonFocusChange(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    let currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      let eleIndex = openDropdowns.indexOf(ele);
      if(eleIndex != currentIndex){ dropdownHide(ele); }
    });
  }

  let closeBtn = dropdownParent.querySelector('.close-submenu');
  if(closeBtn){
    closeBtn.addEventListener('click', (event)=>{
      event.preventDefault();
      let parentElement = event.currentTarget.closest('.dropdown');
      dropdownToggle(parentElement);
    });
  };
}

const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
allDropdowns.forEach(function(ele) {
  dropDownInit(ele)
});

/**
 * Close SubMenu Dropdowns on Regular Nav Item fous or click
 *
 * @param {element} element - Dropdown element
 */
function defaultNavItem(element){
  let _this = element;
  ["focusin", "click", "mouseover", "mouseout"].forEach(function(type){
    _this.addEventListener(type, (e) => {
      e.stopPropagation();
      let currentTarget = e.currentTarget;
      if(!currentTarget.closest('[data-touch-moveable]')){
        hideDropdown(_this.parentElement);
      }
    });
  });

  _this.addEventListener('touchend', (e) => {
    e.stopPropagation();
  });
  
  function hideDropdown(dropdownParent){
    let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    openDropdowns.forEach((ele) => {
      ele.classList.remove('open');
      ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
    });
  }
}

const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
allDefaultNav.forEach(function(ele) {
  defaultNavItem(ele);
});

/**
* Website Overlay for Mobile Menu and Cart Drawer
*/
class siteOverlay extends HTMLElement{
  constructor() {
    super();

    this.menuDrawer = document.querySelector('#mobile-menu-drawer');
    this.cartDrawer = document.querySelector('#ajax-cart');
    this.searchDrawer = document.querySelector('search-modal');
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   * @param {event} Event instance performed
   */
  onClick(event){
    if(this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    if(this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')){
      document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    }
    if(this.searchDrawer && this.searchDrawer.classList.contains('open__modal')){
      document.querySelector('.search-modal__close-button').dispatchEvent(new Event('click'));
    }
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    
    document.getElementById('site-overlay').classList.add('overlay--body');
    document.querySelector('body').classList.add('scroll-fixed');
    document.body.style.overflowY = "hidden";
  }

  /**
   * Hide overlay 
   */
  hideOverlay(){
    document.getElementById('site-overlay').classList.remove('overlay--body');
    document.querySelector('body').classList.remove('scroll-fixed');
    document.body.style.overflowY = "auto";
  }
}
customElements.define("site-overlay", siteOverlay);

/**
 * Slider Component
 *
 */
 class sliderElement extends HTMLElement{
  constructor() {
    super();
    this.sliderEle = this.querySelector('.swiper-slider');
  }

  connectedCallback() {
    if(!this.sliderEle) return;
    
    let thumbSlider = null;
    let sliderOptions = this.sliderEle.getAttribute('data-slider');
    sliderOptions = JSON.parse(sliderOptions);

    // Set up nav slider 
    if(this.sliderEle.hasAttribute('data-nav')){
      thumbSlider = document.querySelector('.' + this.sliderEle.getAttribute('data-nav'));
      if(thumbSlider == null){
        return;
      }

      let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
      thumbSliderOptions = JSON.parse(thumbSliderOptions);
      thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

      sliderOptions.thumbs = {
        swiper: thumbSlider
      }
    }

    let sliderInstance = new Swiper(this.sliderEle, sliderOptions);
    if(this.sliderEle.classList.contains('product-carousel')){
      productSlider = sliderInstance;
    }else if(this.sliderEle.classList.contains('quickshop-slider')){
      quickShopSlider = sliderInstance;
    }

    this.slideChangeEvt(sliderInstance, thumbSlider);
  }

  slideChangeEvt(slider, thumbSlider){   
    slider.on('slideChange', (event) => {
      if(thumbSlider) thumbSlider.slideTo(slider.activeIndex);

      const currentTarget = event.el;
      let activeVideos = currentTarget.querySelectorAll('.custom-video-container.playing--video');
      if(activeVideos.length > 0){        
        activeVideos.forEach((container)=>{
          let video = container.querySelector('custom-video');
          let videoType = video.getAttribute('data-video-type');
          let videoEle = video.querySelector('video') || video.querySelector('iframe');
          if(videoType == 'local'){
            videoEle.pause();
          }else if(videoType == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
      }
    });
  }
 }
 let lookForSwiper = setInterval(() => {
  if(typeof Swiper == 'function'){
    customElements.define('slider-element', sliderElement);
    clearInterval(lookForSwiper);
  } 
}, 100);

/**
* Custom Video
*/
class customVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container.querySelector('[data-trigger-video]');
  }

  connectedCallback() {
    this.bindEvents();
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(event){
    // if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(_event){
    let isOpen = this.container.classList.contains('playing--video');
    if(isOpen){
      this.container.classList.remove('playing--video');
      if(window.globalVariables.templateSuffix == 'about-us'){
        this.container.classList.add('playing--video-about');
        const videoElement = this.videoSection.querySelector('video');
        videoElement.pause();
      }
    }else{
      if(this.videoStatus == 'empty' || this.placementType == 'popup'){
        const videoElement = this._buildVideo();
        videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);;
        this.videoSection.appendChild(videoElement);
        this.videoStatus = 'loaded';
      
        setTimeout(() => {
          (this.placementType == 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
          this.pauseOnVisibilityChange(videoElement);
          this._playVideo(videoElement);
        }, 700);        
      }else{
        const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
        this.container.classList.add('playing--video');
        this._playVideo(videoElement);
      }
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      let videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "src", "https://www.youtube.com/embed/"+ videoID +`?rel=0&showinfo=0&autoplay=${this.dataset.autoplay}&mute=${this.dataset.muted}&controls=${this.dataset.controls}&loop=${this.dataset.loop}&playlist=${videoID}&enablejsapi=1&origin=${window.origin}` );
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    let scrollObserver = new IntersectionObserver((entries) => { 
      if((this.type == 'local' && videoEle == undefined) || (this.type == 'youtube' && videoEle.contentWindow == null)){
        scrollObserver.disconnect();
        return;
      }

      entries.forEach(entry => {
        if(entry.intersectionRatio == 0){
          if(this.type == 'local'){
            videoEle.pause();
          }else if(this.type == 'youtube'){
            videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        }
      });
    });
    scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    let posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo || posterVideo == undefined) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          let sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();         
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }
}
customElements.define("custom-video", customVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = document.querySelectorAll('[data-modal-opener="'+this.id+'"]');
  }

  connectedCallback() {
    if(this.modalOpeners.length > 0) {
      this.modalOpeners.forEach((opener)=>{
        opener.addEventListener('click', ()=>{
          this.show(opener);
        });
      });
    }

    if(this.querySelector('[id^="ModalClose-"]')){
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }

    this.addEventListener('click', (evt) => {
      if (evt.target.nodeName === 'MODAL-DIALOG') this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    siteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    // alert('hi')
    this.modal.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'LocationPopup'){
      document.querySelector('body').classList.remove('open-location');
    }

    if(this.id == 'PopupModal-video'){
      this.querySelector('.video-container').innerHTML = '';
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class Notification extends HTMLElement {
  constructor() {
    super();

    this.paused = false;
    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
  }

  connectedCallback() {
    this.container.addEventListener('mouseover', (event) =>{
      this.paused = true;
    });
    this.container.addEventListener('mouseout', (event) =>{
      this.paused = false;
    });

    if(this.closeBtn){
      this.closeBtn.addEventListener('click', (e)=> {
        e.preventDefault();
        this.container.classList.remove('open');
        this.querySelector('.snotifyToast__title').innerHTML = '';
        this.querySelector('.snotifyToast__body').innerHTML = '';
        this.container.classList.remove("snotify-warning","snotify-info","snotify-error","snotify-success");
        this.querySelector("[data-toast-pr]").removeAttribute("style");
      });
    }
  }

  /**
   * Notification Type
   * @param title 
   * @param body 
   * @param options 
   */
  updateNotification(title, body, options){
    this.container.className = '';
    this.querySelector('.snotifyToast__title').innerHTML = title;
    this.querySelector('.snotifyToast__body').innerHTML = body;

    this.container.classList.add('snotifyToast');
    if(options.type == 'error'){
      this.container.classList.add('snotify-error');
    }else if(options.type == 'warning'){
      this.container.classList.add('snotify-warning');
    }else if(options.type == 'info'){
      this.container.classList.add('snotify-info');
    }else if(options.type == 'success'){
      this.container.classList.add('snotify-success');
    }

    this.container.classList.add('open');
    this.manageToggle(options.timeout)
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  manageToggle(timeout){
    this.progressBar = this.querySelector('[data-toast-pr]');
    let unit = parseInt(timeout) / 1000;
    unit = 100 / unit;
    let width = 0;

    let interval = setInterval(() => {
      if(this.paused == false){
        width += unit;
        this.progressBar.setAttribute('style', `width: ${width}%`);
        if (width > 100) {
          this.closeBtn.dispatchEvent(new Event('click'));
          clearInterval(interval);
        }
      }
    }, 1000)
  }
}
customElements.define("custom-notification", Notification);
window.notificationEle = document.querySelector('custom-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 10000
// });



// hide product information based on website type
let listingProducts = document.querySelectorAll('[data-list-tags]');
listingProducts.forEach( product => {
  let producttags = product.getAttribute('data-list-tags');
  if(producttags.includes(Utility.getCookie('websiteType'))){
    if(product.querySelector('[data-pricewrapperlist]')){
      product.querySelector('[data-pricewrapperlist]').classList.remove('d-none')
    }
  }else{
    if(product.querySelector('[data-pricewrapperlist]')){
    product.querySelector('[data-pricewrapperlist]').classList.add('d-none')
    }
  }
});


// Hide non active links
if(document.body.getAttribute('data-customer') == 'true'){
  if(Utility.getCookie('websiteType') == 'dreamworld'){
    document.querySelector('a[data-tab-type="type2"]').classList.remove('disabled');
    document.querySelector('a[data-tab-type="type1"]').classList.add('disabled');
    document.querySelector('a[data-tab-type="type3"]').classList.add('disabled');
  }else if(Utility.getCookie('websiteType') == 'urbanbeauty'){
    document.querySelector('a[data-tab-type="type3"]').classList.remove('disabled');
    document.querySelector('a[data-tab-type="type1"]').classList.add('disabled');
    document.querySelector('a[data-tab-type="type2"]').classList.add('disabled');
  
  }else if(Utility.getCookie('websiteType') == 'jinnybeauty'){
    document.querySelector('a[data-tab-type="type1"]').classList.remove('disabled');
    document.querySelector('a[data-tab-type="type3"]').classList.add('disabled');
    document.querySelector('a[data-tab-type="type2"]').classList.add('disabled');
  }

  /* Hide Menu Code Start */
  let menuJSONEle = document.querySelector('[data-menuJSON]');
  let menuJSON = JSON.parse(menuJSONEle.textContent);
  let getCurrentLocationID = Utility.getCookie('warehouseID');
  
  if(getCurrentLocationID != undefined){
    let getCurrentLocationIDString = String(getCurrentLocationID);
    for(var data in menuJSON) {
      let locationID = String(data).trim();
      if(getCurrentLocationIDString == locationID){
        menuJSON[data].forEach(function(data1, index) {
          let getTitleEle = document.querySelectorAll(`[data-menuTitle="${data1}"]`);
          if (typeof(getTitleEle) != 'undefined' && getTitleEle != null && getTitleEle.length > 0){
            // getTitleEle.classList.add('d-none');
            getTitleEle.forEach( el => {
              el.classList.add('d-none');
            });
          }
        });
      }
    }

  }
  // else if(websiteType == 'dreamworld'){
  //   for(var data in menuJSON) {
  //     let locationID = String(data).trim();
  //     if(locationID == 'Dreamworld'){
  //       menuJSON[data].forEach(function(data1, index) {
  //         let getTitleEle = document.querySelectorAll(`[data-menuTitle="${data1}"]`);
  //         if (typeof(getTitleEle) != 'undefined' && getTitleEle != null && getTitleEle.length > 0){
  //           getTitleEle.forEach( el => {
  //             el.classList.add('d-none');
  //           });
  //         }
  //       });
  //     }
  //   }
    
  // }else if(websiteType == 'urbanbeauty'){
  //   for(var data in menuJSON) {
  //     let locationID = String(data).trim();
  //     if(locationID == 'Urbanbeauty'){
  //       menuJSON[data].forEach(function(data1, index) {
  //         let getTitleEle = document.querySelectorAll(`[data-menuTitle="${data1}"]`);
  //         if (typeof(getTitleEle) != 'undefined' && getTitleEle != null && getTitleEle.length > 0){
  //           getTitleEle.forEach( el => {
  //             el.classList.add('d-none');
  //           });
  //         }
  //       });
  //     }
  //   }
  // }
  // window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
  /* Hide Menu Code End */
}
// else if(document.body.getAttribute('data-customer') == 'false'){
//   let menuJSONEle = document.querySelector('[data-menuJSON]');
//   let menuJSON = JSON.parse(menuJSONEle.textContent);
//   let getCurrentLocationID = Utility.getCookie('warehouseID');

//   if(websiteType == 'jinnybeauty'){
//     for(var data in menuJSON) {
//       let locationID = String(data).trim();
//         menuJSON[data].forEach(function(data1, index) {
//           let getTitleEle = document.querySelectorAll(`[data-menuTitle="${data1}"]`);
//           if (typeof(getTitleEle) != 'undefined' && getTitleEle != null && getTitleEle.length > 0){
//             // getTitleEle.classList.add('d-none');
//             getTitleEle.forEach( el => {
//               el.classList.add('d-none');
//             });
//           }
//         });
//     }
//   }
// }

// Code to hide parent menu if all child menu is hidden by having 0 products
const ulElements = document.querySelectorAll('.menu-ul-parent');

ulElements.forEach(ul => {
    // Check if any <li> within this <ul> has the specified class
    const hasLiWithClass = Array.from(ul.querySelectorAll(':scope > li')).every(li => li.classList.contains('hide-nav-true'));

    // If a matching <li> is found, add the specified class to the <ul>
    if (hasLiWithClass) {
        ul.classList.add('d-none');
        // ul.closest('.menu-child-li').classList.add('d-none');
    }
});


/**********
 * Product card location based tags
**********/

getCustomerAllCatalogs();
showProductCardBadges ();

async function getCustomerAllCatalogs () {
  if (Utility.getCookie('cif_customerLocationData') === '' && window.globalVariables.customer_id && window.globalVariables.customer_id != null) {
    let customer_id = window.globalVariables.customer_id;
    try {
        const response = await fetch(`https://shopifyapi2.jinny.com/api/get-catalogs?customer_id=${customer_id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        });

        const data = await response.json();
        
        let allLocations = data.companyContactProfiles[0].company.locations.nodes;
        Utility.setCookie('cif_customerLocationData', JSON.stringify(allLocations), 7);
    } catch (error) {
        console.error(error);
    } finally {
        // fetch done
    }
  }
}


function showProductCardBadges() {
  let allProductCardHasTag = document.querySelectorAll('[data-product-grid][data-list-tags]');

  if (allProductCardHasTag.length > 0) {
    allProductCardHasTag.forEach((card) => {
      let allTags = card.dataset.listTags.split(',');
      let showDiscontinueBadge = false;
      let card_badge_discontinued = card.querySelector(".card-badge-discontinued");
      let card_badge_on_sale = card.querySelector(".card-badge-on-sale");
      if (allTags.length > 0) {
        allTags.forEach(tag => {
          if(tag.indexOf(Utility.getCookie('warehouseID')) > -1 && tag.indexOf('blowout') > -1){
            showDiscontinueBadge = true;
          }
        });
        updateSaleBadge(allTags, card_badge_on_sale);
      }
      if (card_badge_discontinued && showDiscontinueBadge == true) {
        card_badge_discontinued.classList.remove('d-none');
      } else {
        card_badge_discontinued?.classList.add('d-none');
      }
    })
  }
}

async function updateSaleBadge (OnsaleTags, card_badge_on_sale) {
  if (window.globalVariables.customer_id && window.globalVariables.customer_id != null && card_badge_on_sale) {
    let customer_id = window.globalVariables.customer_id;
    let showOnSaleBadge = false;
    if (Utility.getCookie('cif_customerLocationData') === '') {
      await getCustomerAllCatalogs();
    }

    let allLocationData = JSON.parse(Utility.getCookie('cif_customerLocationData'));

    if(allLocationData.length > 0) {
      allLocationData.forEach((location) => {
        let currentAllLocId = [location.metafield?.value] ?? null;
        let selectedLocId = Utility.getCookie('warehouseID');
        let allCatalogs = location.catalogs.nodes;
        if (currentAllLocId?.includes(selectedLocId)) {
          allCatalogs.forEach((catalog) => {
            let catalogTitle = catalog.title;
            if (OnsaleTags.length > 0) {
              OnsaleTags.forEach(tag => {
                if(tag.indexOf('ON_SALE') > -1){
                  let onSaleCatalogTitle = tag.split('ON_SALE_').pop();
                  if (onSaleCatalogTitle.indexOf(catalogTitle) > -1) {
                    showOnSaleBadge = true;
                  }
                }
              });
            }
          })
        }
      })
    }

    if (card_badge_on_sale) {
      if(showOnSaleBadge == true || showOnSaleBadge == 'true' && showOnSaleBadge != '') {
        card_badge_on_sale.classList.remove('d-none');
      } else {
        card_badge_on_sale.classList.add('d-none');
      }
    }
  }
}

/**********
 * Product card location based tags END
**********/
document.addEventListener('DOMContentLoaded', function() {
    var interval = setInterval(function() {
        var shadowHost = document.querySelector('shopify-installments');
        if (shadowHost && shadowHost.shadowRoot) {
            var style = document.createElement('style');
            style.textContent = '.shopify-payment-terms { display: none !important; }';
            shadowHost.shadowRoot.appendChild(style);
            clearInterval(interval);
        }
    }, 100);
});
